export default __webpack_public_path__ + "static/media/Study.132265cc.svg";